import { makeStyles, createStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "63px",
      height: "29px",
      padding: "5px 12px 8px 12px",
      borderRadius: "4px",
      borderStyle: "solid",
      color: theme.palette.common.white,
      fontWeight: "bold",
      fontSize: "12px",
      lineHeight: "16px",
      textTransform: "none",
      marginLeft: theme.spacing(1)
    },
  })
);
